module.exports = __webpack_public_path__ + "img/horse-portrait-painting-3.36d35289.png";